export default function isBase64(str: string) {
  if (typeof str !== "string") return false;

  // 去掉 dataURL 前缀（如果有）
  const base64 = str.includes("base64,") ? str.split("base64,")[1] : str;

  // 1️⃣ 基础格式校验（长度必须是4的倍数）
  if (!base64 || base64.length % 4 !== 0) return false;

  // 2️⃣ Base64 正则校验
  const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;
  if (!base64Regex.test(base64)) return false;

  // 3️⃣ 尝试解码验证
  try {
    if (typeof window !== "undefined") {
      atob(base64);
    } else {
      Buffer.from(base64, "base64");
    }
    return true;
  } catch (err) {
    return false;
  }
}
